<template>
  <svg viewBox="5.5 6 14.32 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3008 7.46484L15.9326 12H5.5V14H15.9346L11.3008 18.5352L12.6992 19.9648L19.8145 13.001L12.6992 6.03516L11.3008 7.46484Z"
      fill="currentColor"
    />
  </svg>
</template>
